module.exports = __webpack_public_path__ + "static/16-04330f55a2a3348bd7c1a4e3c77a68ee.png";